import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { AnnotaionDto } from '../dto/LectionImageDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiAddAnnatation = async (
  section: string,
  route: string,
  page: string,
  dto: AnnotaionDto
) => {
  const params: IApiParams = {
    url: `/admin/addAnnotation.php?section=${section}&route=${route}&page=${page}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
